import { render, staticRenderFns } from "./Forms.vue?vue&type=template&id=f30d8c60"
import script from "./Forms.vue?vue&type=script&lang=js"
export * from "./Forms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f30d8c60')) {
      api.createRecord('f30d8c60', component.options)
    } else {
      api.reload('f30d8c60', component.options)
    }
    module.hot.accept("./Forms.vue?vue&type=template&id=f30d8c60", function () {
      api.rerender('f30d8c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/form/Forms.vue"
export default component.exports